import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const DataTableCard = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;

    .p-datatable .p-column-header-content {
        display: flex;
        justify-content: center;
    }

    .p-datatable .p-datatable-thead > tr > th{
        background: #84DFC1;
        color: ${colors.greyscale.darker_grey};
        font-size: 14px;
        padding: 0.7rem 2rem;
        font-weight: bold;
        outline-width: 5px;
    }

    .p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {
        background: #84DFC1;
    }
    
    .p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {
        background: #84DFC1;
    }

    .p-datatable .p-datatable-thead .pi {
        font-size: 12px;
    }

    .p-datatable .p-datatable-tbody > tr > td {
        border: 2px solid white;
        padding: 0.3rem 1rem;
    }

    .p-datatable .p-datatable-tbody .pi {
        font-weight: bold;
    }

    .p-splitbutton.p-button-text > .p-button {
        color: ${colors.greyscale.darker_grey} !important;
    }

    .p-inactive {
        color: ${colors.greyscale.grey} !important;
    }
`